import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const Detail = lazy(() => import('./:period/Index'))

export const EurocontrolRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--purchase']}>
    <Route index element={<Index />} />
    <Route path=':period' element={<Detail />} />
  </SubRouter>
))
